module.exports = __webpack_public_path__ + "static/media/FACURRYM_MENU-normal.7cb87976.png";